import { Component } from '@angular/core';
import {Subscription} from "rxjs";
import {GameService} from "../../../../services/game.service";
import {Game} from "../../../../models/game.class";
import {TrackingHelperService} from "../../../../services/tracking-helper.service";

@Component({
  selector: 'app-recommended',
  templateUrl: './recommended.component.html',
  styleUrls: ['./recommended.component.scss']
})
export class RecommendedComponent {

  recommendedGames: Game[] = [];
  recommendedSubs?: Subscription;

  favouritesSubs?: Subscription;
  favouriteIds: number[] = [];

  randomGamesForCarousel: Game[] = [];
  gameSubs?: Subscription;

  userHasTracker: boolean;


  constructor(
    private gameService: GameService,
    private trackingService: TrackingHelperService
  ) {
    this.userHasTracker = !!this.trackingService.getTracker();

    this.recommendedSubs = this.gameService.getRecommendedGames().subscribe(games => {
        this.recommendedGames = games;
    })

    this.gameSubs = this.gameService.getGames().subscribe(games => {
      this.randomGamesForCarousel = this.gameService.pickRandomGames(games.all, 16);
    })

  }

  ngOnInit(){
    this.favouritesSubs = this.gameService.favouriteGameIds$.subscribe(favouriteIds => {
      this.favouriteIds = favouriteIds
    })
  }

  ngOnDestroy(){
    this.recommendedSubs?.unsubscribe();
    this.favouritesSubs?.unsubscribe();
    this.gameSubs?.unsubscribe();
  }



}
